/**
 * @abstract
 */
export class CustomerRepository {
    /**
     * @abstract
     * @return {Promise<Customer[]>}
     */
    async all() {

    }
}